import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-300af462"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ipt-inner" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "p-6" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = ["textContent"]
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "ipt-actions" }
const _hoisted_8 = { class: "ipt-cta" }
const _hoisted_9 = ["textContent"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4 ml-2",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5 12h14" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12 5l7 7-7 7" })
], -1))
const _hoisted_11 = {
  key: 0,
  class: "ipt-views"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4 mr-1",
  stroke: "currentColor",
  "stroke-width": "2",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  })
], -1))
const _hoisted_13 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    tag: "div",
    to: _ctx.tile.url,
    class: _normalizeClass(["invoice-preview-tile ipt ipt-container", `inv-${_ctx.tile.slug}`])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.tile.img)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "ipt-img",
              src: _ctx.tile.img,
              alt: "blog"
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", {
            class: "ipt-category",
            textContent: _toDisplayString(_ctx.tile.category)
          }, null, 8, _hoisted_4),
          _createElementVNode("h1", {
            class: "ipt-title",
            textContent: _toDisplayString(_ctx.tile.title ?? _ctx.tile.name)
          }, null, 8, _hoisted_5),
          _createElementVNode("p", {
            class: "ipt-desc",
            textContent: _toDisplayString(_ctx.tile.description)
          }, null, 8, _hoisted_6),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", _hoisted_8, [
              _createElementVNode("span", {
                textContent: _toDisplayString(_ctx.tile.actionTxt ?? `Try`)
              }, null, 8, _hoisted_9),
              _hoisted_10
            ]),
            (_ctx.tile.views)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("span", {
                    textContent: _toDisplayString(_ctx.tile.views)
                  }, null, 8, _hoisted_13)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["to", "class"]))
}